import BooleanInput from "../components/form/BooleanInput.vue";
import ImageUploadBox from "../components/upload/ImageUploadBox.vue";
import TextInput from "../components/form/TextInput.vue";
import TextareaInput from "../components/form/TextareaInput.vue";
import dynamicEvents from "./dynamicEvents";
export default {
  props: ["protocol", "step", "stepValues"],
  components: { BooleanInput, ImageUploadBox, TextInput, TextareaInput },
  mixins: [dynamicEvents],
  data() {
    return {}
  },
  created: function () {},
  beforeMount: function () {
    let routeName = this.step.vue_route_name
    if (this.step.pivot.config !== undefined && this.step.pivot.config !== null) {
      let config = JSON.parse(this.step.pivot.config)
      if(config.vue_storage_path) {
        routeName = config.vue_storage_path
      }
      this.config = config
    }
    else {
      this.config = {}
    }
    if (!this.protocol.saved_values.steps[routeName].saved_values) {
      this.protocol.saved_values.steps[routeName].saved_values = {}
      for (var key in this.stepValues) {
        this.protocol.saved_values.steps[routeName].saved_values[key] = this.stepValues[key]
      }
    }
    else {
      for (var key2 in this.stepValues) {
        if (this.protocol.saved_values.steps[routeName].saved_values[key2]) {
          this.stepValues[key2] = this.protocol.saved_values.steps[routeName].saved_values[key2]
        }
      }
    }
    for (var f in this.protocol.saved_values.steps[routeName].saved_values) {
      if(!this.stepValues[f]) {
        this.stepValues[f] = this.protocol.saved_values.steps[routeName].saved_values[f]
      }
    }
    this.protocol.saved_values.steps[routeName].saved_values = this.stepValues
    
    if (this.stepValues.finished) {
      this.setFinished()
    }
    
    this.updateFields()
  },
  computed: {
    finished: function () {
      return true;
    }
  }
}